import { faArrowRightLong } from "@fortawesome/sharp-regular-svg-icons/faArrowRightLong";

import type { VariantButtonAppearanceEnum } from "~components/Button/styles.css";
import type { IconFontAwesomeProps } from "~components/IconFontAwesome";

interface ComputeButtonLinkIconRightArgs {
  appearance: VariantButtonAppearanceEnum;
  iconLeft?: IconFontAwesomeProps["icon"];
  shouldHaveArrowIcon?: boolean;
}

export const computeButtonLinkIconLeft = ({
  appearance,
  iconLeft,
  shouldHaveArrowIcon,
}: ComputeButtonLinkIconRightArgs) => {
  if (iconLeft) return iconLeft;

  if (!shouldHaveArrowIcon) return undefined;

  if (appearance === "tertiary") {
    return faArrowRightLong;
  }

  return undefined;
};
